import { configureStore } from '@reduxjs/toolkit';
import activitiesReducer from './reducers/activities';
import quickPayReducer from './reducers/quickPay';
export const storeOptions = {
    reducer: {
        activities: activitiesReducer,
        quickPay: quickPayReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
